import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen, IsXsScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const AccountSettingsHelp = () => {
  const isMdScreen = IsMdScreen();
  const paddingValue = IsXsScreen() ? 1 : 3;

  return (
    <>
      <Stack padding={paddingValue} direction={"row"}>
        <ShContainer maxWidth='xl' margin='auto'>
          <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
            Account Settings
          </ResourceTypography>
          <ResourceTypography variant="body1" paragraph>
            Customize your account settings to match your organization's needs. Manage company information,
            user permissions, and system preferences in one centralized location.
          </ResourceTypography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Company Information
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Update your company details, including contact information, location, and branding.
            This information will be used across job postings and candidate communications.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            User Management
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Manage team members and their access levels. Assign roles, set permissions, and control
            who can perform specific actions within the system.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Notification Preferences
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Customize your notification settings to stay informed about important updates. Choose
            which events trigger notifications and how you want to receive them.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Security Settings
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Configure security settings to protect your account and data. Set up two-factor
            authentication, manage password policies, and control access to sensitive information.
          </Typography>

          <Box paddingTop={2} paddingBottom={3}>
            <ShButton
              component={RouterLink}
              to="/employer/settings/account"
              color="primary"
              variant="contained"
            >
              Access Account Settings
            </ShButton>
          </Box>
        </ShContainer>
        {!isMdScreen && <CommonQuestionSidebar />}
      </Stack>
    </>
  );
};

export default AccountSettingsHelp; 